import Link from 'next/link';
import styles from '../../styles/Navbar.module.css';
import { Assets } from '../../src/list/Assets';
import { useState, useEffect, useRef } from 'react';
import SideNavbar from '../components/SideNavbar.js'
import Image from "next/image";
import { toggleTheme, MOON_PATH, SUN_PATH } from '../lib/theme';
import { useRouter } from 'next/router';
import { trackSearch } from '../lib/behavior';

const Navbar = () => {

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredGames, setFilteredGames] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [imageLoaded, setImageLoaded] = useState(false);
  // Search list is fetched on first use (not bundled), see scripts/build-search-index.js
  const [searchIndex, setSearchIndex] = useState(null);
  const indexRequested = useRef(false);
  // Phones show a round search button; the search pill opens over the header
  const [mobileSearch, setMobileSearch] = useState(false);
  const searchInputRef = useRef(null);

  // Glamzy Lookbook's looks (public/search-looks.json), shown in their own section above the games
  const [looksIndex, setLooksIndex] = useState(null);
  const [filteredLooks, setFilteredLooks] = useState([]);

  const loadSearchIndex = () => {
    if (indexRequested.current) return;
    indexRequested.current = true;
    fetch('/search-index.json')
      .then((res) => res.json())
      .then(setSearchIndex)
      .catch(() => { indexRequested.current = false; });
    fetch('/search-looks.json')
      .then((res) => res.json())
      .then(setLooksIndex)
      .catch(() => setLooksIndex([]));
  };

  // Filter once the list is available, so typing before it arrives still shows results
  useEffect(() => {
    if (!searchTerm || !searchIndex) return;
    const term = searchTerm.toLowerCase();
    const results = searchIndex.filter(game =>
      game.title.toLowerCase().includes(term)
    );
    // looks: name matches first, then looks whose world matches ("summer", "holidays"...), at most 4
    const looks = looksIndex || [];
    const byName = looks.filter(l => l.title.toLowerCase().includes(term));
    const byWorld = looks.filter(l => !byName.includes(l) && l.world.toLowerCase().includes(term));
    const lookResults = byName.concat(byWorld).slice(0, 4);
    setFilteredGames(results);
    setFilteredLooks(lookResults);
    setNoResults(results.length === 0 && lookResults.length === 0);
    trackSearch(searchTerm, () => results.length + lookResults.length);
  }, [searchTerm, searchIndex, looksIndex]);


const myImageLoader = ({ src }) => {
  return `${src}?w=100&q=100`;
};
  // Desktop: show / hide the side menu (rail below 1800px, full panel from 1800px; remembered).
  // Phones: open the slide-in drawer.
  // Glamzy theme pages (a look's game, /glamzy/<look>): the side menu starts hidden so the game has the
  // room; the menu button still shows it there, for that page only (the saved choice is the rest of the
  // site's). pages/_document.js does the same before the first paint.
  const router = useRouter();
  const themePage = router.pathname === '/glamzy/[slug]' || router.pathname.startsWith('/glamzy/trip/');
  useEffect(() => {
    const root = document.documentElement;
    let saved = null;
    try { saved = localStorage.getItem('pcg_sidenav'); } catch (e) {}
    if (themePage) root.removeAttribute('data-sidenav');
    else if (saved !== 'closed') root.setAttribute('data-sidenav', 'open');
  }, [themePage]);

  const toggleSidebar = () => {
    if (window.matchMedia('(min-width: 771px)').matches) {
      const root = document.documentElement;
      const open = root.getAttribute('data-sidenav') !== 'open';
      if (open) root.setAttribute('data-sidenav', 'open');
      else root.removeAttribute('data-sidenav');
      if (!themePage) try { localStorage.setItem('pcg_sidenav', open ? 'open' : 'closed'); } catch (e) {}
      return;
    }
    setIsSidebarOpen(prevState => !prevState);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  
  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);

    
    if (term.trim() !== '') {
      // Add your search submit logic here
      setShowResults(true);
    } 

    if (term) {
      loadSearchIndex();
      setShowResults(true);
    } else {
      setShowResults(false);
      setNoResults(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
  
  };

  const handleCloseResults = () => {
    setSearchTerm(''); 
    setShowResults(false);
  };

  const handleClearSearch = () => {
    setSearchTerm(''); // Clear the input field
    setShowResults(false); // Optionally close the search results
  };

  const handleClearSearch_2 = () => {
    setTimeout(() => {
      handleClearSearch();
    }, 500); 
  };


  return (
    <>
    <nav className={styles.navbar}>
      
      <div className={styles.logo}>
      <button type="button" aria-label="Menu"
        className={`${styles.Nav_icon} ${isSidebarOpen ? styles.rotated : ''}`} onClick={toggleSidebar}>
        {/* fold / unfold icon: the arrow points right while the menu is hidden, left while it is shown (Navbar.module.css) */}
        <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 6.5 H20 M12 12 H20 M10 17.5 H20" />
          <path className={styles.navArrow} d="M4 9 L7 12 L4 15" />
        </svg>
      </button>

        <Link href="/" passHref data-logo="">
          <div>
          <Image src={Assets[0].logo_header} alt={"Logo"} className={`${styles.img_logo} unset_position`} fill/>
            </div>
        </Link>

          
      </div>
      
      
      <button type="button" aria-label="Search games" className={styles.mobileSearchBtn}
        onClick={() => { setMobileSearch(true); loadSearchIndex(); setTimeout(() => searchInputRef.current?.focus(), 0); }}>
        <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round"><circle cx="11" cy="11" r="7" /><path d="M20 20 L16.5 16.5" /></svg>
      </button>

      <form onSubmit={handleSearchSubmit} className={`${styles.searchForm} ${mobileSearch ? styles.searchOpen : ''}`}>
      <button type="button" aria-label="Close search" className={styles.searchBack}
        onClick={() => { handleClearSearch(); setMobileSearch(false); }}>
        <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M15 5 L8 12 L15 19" /></svg>
      </button>
      <input
          ref={searchInputRef}
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleSearchChange}
          onFocus={loadSearchIndex}
          className={styles.searchInput}
          data-clarity-unmask="true"
          id='Unmask'
        />
        {showResults&&(<div className={styles.Close_icon} onClick={handleClearSearch}> 
        <Image src={Assets[0].nav_Clear_icon} alt={"Close Icon"} className={`${styles.s_icon} unset_position`} fill />
        </div>)}

        {!showResults&&(<div className={styles.Search_icon} >
        <Image src={Assets[0].nav_S_icon} alt={"Search Icon"} className={`${styles.s_icon} unset_position` } fill />
        </div>)}
        
        {/* <button type="submit" className={styles.searchButton}>Search</button> */}

        {showResults && (
          <div className={styles.searchResults}>
            {!noResults && filteredLooks.length > 0 && (
              <>
                <div className={styles.resultsHead}>
                  Glamzy Lookbook · {filteredLooks.length} look{filteredLooks.length === 1 ? '' : 's'}
                </div>
                <div className={styles.Results_Holder} onClick={handleClearSearch_2}>
                  {filteredLooks.map((look) => (
                    <Link href={`/glamzy/${look.slug}`} className={styles.searchResultItem} key={look.slug} prefetch={false}>
                      <span className={`${styles.resultImage} ${styles.lookImage}`}>
                        {look.cover && <img src={look.cover} alt="" loading="lazy" />}
                      </span>
                      <span className={styles.resultTitle}>
                        {look.title}
                        <small className={styles.resultWorld}>{look.world} · Dress up look</small>
                      </span>
                      <span className={styles.resultPlay} aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8.5 4.5 L19.5 12 L8.5 19.5 Z" /></svg>
                      </span>
                    </Link>
                  ))}
                </div>
              </>
            )}
            {!noResults && filteredGames.length > 0 && (
              <>
                <div className={styles.resultsHead}>
                  {searchIndex ? `${filteredGames.length} game${filteredGames.length === 1 ? '' : 's'} found` : 'Searching…'}
                </div>
                <div className={styles.Results_Holder} onClick={handleClearSearch_2}>
                  {filteredGames.map((game, index) => (
                    <Link href={game.path[0]} className={styles.searchResultItem} key={index} prefetch={false}>
                      <span className={styles.resultImage}>
                        <Image src={game.thumb} alt={game.title} fill sizes="104px" />
                        {game.platform === 'pc' && (
                          <span className={styles.pcBadge}>
                            <Image loader={myImageLoader} src="/assets/pc-icon.svg" alt="" fill sizes="30px" loading="lazy" className="PC_Icon" />
                          </span>
                        )}
                      </span>
                      <span className={styles.resultTitle}>{game.name[0]}</span>
                      <span className={styles.resultPlay} aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8.5 4.5 L19.5 12 L8.5 19.5 Z" /></svg>
                      </span>
                    </Link>
                  ))}
                </div>
              </>
            )}
            {noResults && (
              <div className={styles.noResults}>
                <strong>No games found for “{searchTerm}”</strong>
                <span>Try a shorter word, like “dress up”, “barbie” or “cooking”.</span>
              </div>
            )}
          </div>
        )}
      </form>
      {/* dims the page while results are open; click to close */}
      {showResults && <div className={styles.overlay} onClick={handleClearSearch}></div>}

      {/* Quick links (desktop only, hidden on small screens in Navbar.module.css) */}
      <div className={styles.navPills}>
        <Link href="/categories/new-games" prefetch={false} className={styles.pillLight}>New</Link>
        <Link href="/categories/exclusive-games" prefetch={false} className={styles.pill}>Exclusive</Link>
        <Link href="/all-categories" prefetch={false} className={styles.pill}>Categories</Link>
      </div>

      {/* light / dark theme (desktop; phones have it in the side menu) */}
      <button type="button" className={styles.themeBtn} aria-label="Switch light or dark theme" title="Light / dark theme" onClick={toggleTheme}>
        <svg className={styles.moonIcon} aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d={MOON_PATH} /></svg>
        <svg className={styles.sunIcon} aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d={SUN_PATH} /></svg>
      </button>

      {/* <ul className={styles.navLinks}>
        <li>
          <Link href="/games">
            <a>Games</a>
          </Link>
        </li>
        <li>
          <Link href="/categories">
            <a>Categories</a>
          </Link>
        </li>
        <li>
          <Link href="/about">
            <a>About</a>
          </Link>
        </li>
      </ul> */}

    </nav>
    <SideNavbar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
    
    </>
  );
};
// 

export default Navbar;
